/* ======================================================================================
		INIT
====================================================================================== */

// DEVICE 
import {getDeviceType} from '../../__js_module__/devicetype.js';
window.getDeviceType = getDeviceType;
window.ISS = {};
ISS.device_type = getDeviceType();

// IMGCHANGE
import {imgChange} from '../../__js_module__/imgchange.js';
window.imgChange = imgChange;

// LOADING
import {showLoading,loadImgCheck} from '../../__js_module__/loading.js';
window.showLoading = showLoading;
window.loadImgCheck = loadImgCheck;

// mfp
//import {mfpYT,mfpIMG,mfpIMGGALLERY,mfpIFRAME,iFrameHeight,mfpINLINE,mfpINLINEGALLERY} from '../../__js_module__/magnificpopup.js';
//window.mfpYT = mfpYT;

// GLOBAL変数
window.initAnime_Page = function(){};
window.pageLoadFlag = false;
window.spSizeFlag = false;
//window.mfpDispFlag = false;
window.showLoading;

// イージングタイプ
/* const easingTypeA = [0,.65,.44,1];
const easingTypeB = [0,.69,.28,1];
const easingTypeC = [0,.75,.12,1];
const easingTypeSP1 = [.65,.07,.23,.82]; */

window.easingType = {
	typeA:[0,.65,.44,1],
	typeB:[0,.69,.28,1],
	typeC:[0,.75,.12,1],
	typeSP1:[.65,.07,.23,.82]
}


/* ======================================================================================
		FUNCTION
====================================================================================== */

// PC/SP切り替え
//function is_size(){
window.is_size = function(){
	if(typeof window.matchMedia == 'undefined'){
		return (($(window).width() <= 768));
	}else{
		if(window.matchMedia('(max-width:768px)').matches){
			return true;
		}else{
			return false;
		}
	}
}

// ANCER
window.anc = function(){
	$('a.anc').on('click', function(){
		let target = $(this).attr('href');
		if(target != "#top"){
			ancFunc(target)
		}else{
			//$('html,body').animate({ scrollTop: 0 },400,"easeOutQuint");
			gsap.to($('html,body'), {scrollTop: 0, duration: 0.4, overwrite: true, onComplete: () => {}});

		}
		return false;
	});
}
function ancFunc(tgt){
	let adj = $(window).height()/10;
	let posi = $(tgt).offset().top - adj;
	//$('html,body').animate({ scrollTop: posi },600,"easeOutQuint");
	gsap.to($('html,body'), {scrollTop: posi, duration: 0.6, ease: "power4.out", overwrite: true, onComplete: () => {}});
}


// スクロールバー幅
const calcScrollbarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
	// カスタムプロパティの値を更新する
	document.documentElement.style.setProperty('--scrollbarW', `${scrollbarWidth}px`);
};
calcScrollbarWidth();
// 表示されたとき
window.addEventListener('load', calcScrollbarWidth);
// リサイズしたとき
window.addEventListener('resize', calcScrollbarWidth);


/* ======================================================================================
		ACTION
====================================================================================== */
$(function(){

	imgChange();
	anc();
	
});

